import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = {
    points: Array,
    triggerIndex: Number
  }

  connect() {
    if (!this.hasPointsValue || this.pointsValue.length < 2) return

    const canvas = this.element.querySelector("canvas")
    if (!canvas) return

    const labels = this.pointsValue.map((point) => point.label)
    const values = this.pointsValue.map((point) => point.value)
    const ctx = canvas.getContext("2d")
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.offsetHeight || 160)
    gradient.addColorStop(0, "rgba(37, 99, 235, 0.22)")
    gradient.addColorStop(1, "rgba(37, 99, 235, 0)")

    const triggerIndex = this.hasTriggerIndexValue ? this.triggerIndexValue : values.length - 1
    const pointRadius = values.map((_, index) => (index === triggerIndex ? 5 : 0))
    const pointBackgroundColor = values.map((_, index) =>
      index === triggerIndex ? "#f59e0b" : "#2563eb"
    )

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Coût par portion",
            data: values,
            borderColor: "#2563eb",
            backgroundColor: gradient,
            borderWidth: 2.5,
            fill: true,
            tension: 0.35,
            pointRadius,
            pointHoverRadius: 6,
            pointBackgroundColor,
            pointBorderColor: "#fff",
            pointBorderWidth: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { left: 4, right: 8, top: 8, bottom: 4 }
        },
        interaction: { intersect: false, mode: "index" },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: "rgba(15, 23, 42, 0.9)",
            titleColor: "#f8fafc",
            bodyColor: "#f8fafc",
            borderColor: "rgba(37, 99, 235, 0.4)",
            borderWidth: 1,
            cornerRadius: 8,
            padding: 10,
            callbacks: {
              label: (context) => {
                const value = context.parsed.y
                return ` ${value.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}`
              }
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            border: { display: false },
            ticks: {
              color: "#94a3b8",
              font: { size: 11 },
              maxRotation: 0
            }
          },
          y: {
            beginAtZero: false,
            grid: {
              color: "rgba(148, 163, 184, 0.2)"
            },
            border: { display: false },
            ticks: {
              color: "#94a3b8",
              font: { size: 11 },
              maxTicksLimit: 4,
              callback: (value) =>
                value.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 })
            }
          }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
